import React from 'react'

const NiDrawr = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 5L7 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path><path d="M4 12L7 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path><path d="M4 19L7 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path><path opacity="0.6" d="M20 5L11 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path><path opacity="0.6" d="M20 12L11 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path><path opacity="0.6" d="M20 19L11 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>
  )
}

export default NiDrawr
